import { initializeApp } from "firebase/app";

// TODO: Jet's Prod Firebase Credentials here (may use them instead of dev app): https://github.com/LOKE/client-jets/pull/278
const firebaseApp = initializeApp({
  apiKey: "AIzaSyD5fv8hkBb1ykaJKjWni7_2GiJx2rUnFgQ",
  authDomain: "loke-app-dev.firebaseapp.com",
  databaseURL: "https://loke-app-dev.firebaseio.com",
  projectId: "loke-app-dev",
  storageBucket: "loke-app-dev.firebasestorage.app",
  messagingSenderId: "281161935903",
  appId: "1:281161935903:web:7d95a937550c287a9bb92a",
  measurementId: "G-5V8KCE672Y",
});

export default firebaseApp;

export const vapidKey =
  "BJCGLkH6r4JrfHxHSriYIdJgRd7yH5bL1BCLDzexvNxk8TuoaBSq6yeUwRATof-TFteQSvnLhdx5E6SNYwHZlcU";
